import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, IDField } from "@/components/AuthShell";
import { IDButton } from "@/marketing/brand";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await forgotPassword(email.trim());
      setSent(true);
      if (res?.dev_link) setDevLink(res.dev_link);
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send you a secure link to set a new password."
      footer={<p className="id-sans text-center text-sm text-[var(--id-charcoal)]/60">Remembered it? <Link to="/login" className="text-[var(--id-walnut)] font-medium id-link-underline">Sign in</Link></p>}>
      {!sent ? (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <IDField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-email" autoComplete="email" />
          <IDButton as="button" type="submit" variant="solid" disabled={busy} className="w-full !py-3.5" testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</IDButton>
        </form>
      ) : (
        <div className="rounded-2xl border border-[var(--id-mist)] bg-white p-6" data-testid="forgot-sent">
          <p className="id-sans text-[15px] text-[var(--id-charcoal)]/75">If an account exists for <strong>{email}</strong>, a reset link is on its way.</p>
          {devLink && (
            <div className="mt-4 rounded-xl bg-[var(--id-mist)]/50 p-4">
              <p className="id-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--id-gold)]">Dev mode</p>
              <p className="id-sans mt-1 text-[13px] text-[var(--id-charcoal)]/70">Email delivery isn't configured yet, so use this link directly:</p>
              <a href={devLink} data-testid="forgot-dev-link" className="id-sans mt-2 block break-all text-[13px] text-[var(--id-walnut)] underline">{devLink}</a>
            </div>
          )}
        </div>
      )}
    </AuthShell>
  );
}
